import React, { Component } from 'react';
import { Wrapper } from '../../components_desktop/css_global/utils.css';

class ReviewsList extends Component {
  componentDidMount() {
    const script = document.createElement('script');

    script.src = `https://staticw2.yotpo.com/${process.env.YOTPO_KEY}/widget.js`;
    script.async = true;

    document.head.appendChild(script);
    this.renderWidget();
    this.injectScore();
  }

  renderWidget() {
    if (window.yotpo === undefined) {
      return;
    }
    // FIXME: This is potentially fragile since it's not documented. Ideally we should be using yotpo api.
    window.yotpo.initialized = false;
    window.yotpo.clean();

    window.yotpo.init();
  }

  injectScore() {
    const reviews = document.querySelector('div.yotpo-main-widget');

    if (reviews) {
      const addNode = (parent, rating, numReviews) => {
        const divCssText = 'color: black; font-size: 1.5em; margin-bottom: 10px;';
        const spanCssText = 'color: black; font-size: 1em; font-weight: bold;';
        const d = document.createElement('div');
        d.setAttribute('style', divCssText);
        d.innerHTML = `Italist scored <span  style="${spanCssText}"> ${rating} / 5 </span>`;
        const target = document.querySelector('div.yotpo-regular-box.yotpo-bottomline.yotpo-bottomline-2-boxes');
        target.insertBefore(d, target.firstChild);
      };

      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'childList') {
            fetch(`https://api.yotpo.com/v1/apps/${process.env.YOTPO_KEY}/bottom_lines`)
              .then(response => response.json())
              .then(data => {
                const rating = data.response.bottomlines[0].product_score;
                const numReviews = data.response.bottomlines[0].total_reviews;
                addNode(reviews, rating, numReviews);
              })
              .catch(err => console.log('error', err));
            observer.disconnect();
          }
        });
      });

      const config = { attributes: true, characterData: true, childList: true };
      observer.observe(reviews, config);
    }
  }

  render() {
    return (
      <div>
        <Wrapper className="reviews-widget-container">
          <div
            className="yotpo yotpo-main-widget"
            data-product-id="yotpo_site_reviews"
            data-url="italist.com"
            data-name="italist Site Reviews"
            data-yotpo-element-id="1"
          />
        </Wrapper>
      </div>
    );
  }
}

export default ReviewsList;
